/** Stale time for React Query cache (4 minutes) */
export const QUERY_STALE_TIME_MS = 4 * 60 * 1000;

/** Interval for refreshing auth token (4 minutes) */
export const TOKEN_REFRESH_INTERVAL_MS = 4 * 60 * 1000;
